import app from "@cms/core/app";
import Verbleif from "@verbleif/lib/src/plugin";
import { localeReady } from "@verbleif/lib/src/translations/i18n";
import {
  // Components
  Menu,
  options,
  Tooltip,
  vClosePopper,
  // Directives
  vTooltip,
} from "floating-vue";
import "@unovis/ts/styles";
import "@verbleif/lib/src/global.css";
import "@verbleif/lib/src/scss/Fonts.css";
import "animate.css";
import "@cms/core/config";
import "@cms/core/plugin/sentry";
import "@verbleif/shared/src/components/Sonner/toastDefaults";
import "@cms/core/plugin/import";
import "floating-vue/dist/style.css";

if (import.meta.env.DEV) {
  if (window.location.hostname === "localhost") {
    window.location.hostname = "cms.verbleif.localhost";
  }
}

async function initializeApp() {
  if (import.meta.env.VITE_MOCKED === "true") {
    const { disableMercure } = await import("@verbleif/lib/src/composables/Mercure/useMercure");
    disableMercure.value = true;

    const { setupWorker } = await import("msw/browser");
    const { handlers, webHandlers } = await import("@verbleif/mocks/src/handlers");
    // ...handlers goes last because it ends with a * wildcard that keeps dynamic imports unmocked
    await setupWorker(...webHandlers, ...handlers).start({ onUnhandledRequest: "bypass" });
  }
  options.themes["verbleif-popper"] = {
    $extend: "dropdown",
  };
  options.themes["verbleif-select"] = {
    $extend: "dropdown",
  };
  options.themes["verbleif-popper-bounded"] = {
    $extend: "dropdown",
  };
  options.themes["verbleif-tooltip"] = {
    $extend: "tooltip",
  };
  options.themes["verbleif-tooltip-gray"] = {
    $extend: "tooltip",
  };
  options.themes["verbleif-tooltip-ac"] = {
    $extend: "tooltip",
  };
  options.themes["verbleif-tooltip-dark"] = {
    $extend: "tooltip",
  };

  options.themes["verbleif-tooltip-solid"] = {
    $extend: "tooltip",
  };
  const { default: router } = await import("@cms/core/plugin/router");
  await localeReady;
  app
    .directive("tooltip", vTooltip)
    .directive("close-popper", vClosePopper)

    .component("VVTooltip", Tooltip)
    .component("VMenu", Menu)
    .use(Verbleif)
    .use(router)
    .mount("#app");
}

initializeApp().then();
